import Head from 'next/head';
import Link from 'next/link';

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Política de Privacidad - Externaliza2</title>
      </Head>
      <div className="min-h-screen bg-calm-bg">
        <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
          <Link href="/" className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 mb-6">
            <span className="material-symbols-outlined text-base">arrow_back</span>
            Volver al inicio
          </Link>

          <article className="bg-calm-bg rounded-huge shadow-sm border border-calm-border p-6 sm:p-10">
            <h1 className="text-2xl sm:text-3xl font-light text-calm-text mb-2">
              Política de Privacidad
            </h1>
            <p className="text-sm text-calm-muted mb-8">
              Última actualización: Febrero 2026 · Versión 1.0
            </p>

            <div className="prose prose-calm max-w-none space-y-6 text-sm leading-relaxed">
              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">1. Responsable del Tratamiento</h2>
                <p className="text-calm-muted">
                  <strong>EXTERNALIZA2 CONSULTORES, S.L.</strong><br />
                  Correo electrónico: administracion@externaliza2.com<br />
                  La presente política de privacidad se aplica a la plataforma Externaliza2 y todos sus servicios asociados.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">2. Base Legal y Finalidades</h2>
                <p className="text-calm-muted">Tratamos tus datos personales conforme al Reglamento General de Protección de Datos (RGPD) UE 2016/679 y la Ley Orgánica 3/2018 (LOPDGDD):</p>
                <ul className="list-disc pl-5 space-y-2 text-calm-muted mt-2">
                  <li><strong>Ejecución del contrato (Art. 6.1.b RGPD):</strong> Gestión de tu cuenta, procesamiento de documentos contables y fiscales, y prestación de servicios de asesoría.</li>
                  <li><strong>Obligación legal (Art. 6.1.c RGPD):</strong> Cumplimiento de obligaciones tributarias (Ley General Tributaria Art. 66) y mercantiles (Código de Comercio Art. 30).</li>
                  <li><strong>Consentimiento (Art. 6.1.a RGPD):</strong> Procesamiento mediante inteligencia artificial, envío de notificaciones por email, y análisis de uso de la plataforma.</li>
                  <li><strong>Interés legítimo (Art. 6.1.f RGPD):</strong> Seguridad de la plataforma, prevención de fraude, y mejora del servicio.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">3. Datos Tratados</h2>
                <ul className="list-disc pl-5 space-y-2 text-calm-muted">
                  <li><strong>Datos identificativos:</strong> Nombre, email, teléfono, NIF/CIF.</li>
                  <li><strong>Datos profesionales:</strong> Razón social, dirección fiscal, tipo de empresa.</li>
                  <li><strong>Datos financieros:</strong> Facturas, asientos contables, datos de IVA, retenciones, libro registro.</li>
                  <li><strong>Datos de uso:</strong> Historial de acceso, preferencias, interacciones con la plataforma.</li>
                  <li><strong>Datos técnicos:</strong> Dirección IP, navegador, dispositivo (para seguridad y auditoría).</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">4. Procesamiento mediante Inteligencia Artificial</h2>
                <p className="text-calm-muted">
                  Conforme al Art. 22 del RGPD, utilizamos IA para:
                </p>
                <ul className="list-disc pl-5 space-y-2 text-calm-muted mt-2">
                  <li>Extracción automática de datos de facturas y documentos financieros (OCR).</li>
                  <li>Verificación y validación de datos contables.</li>
                  <li>Análisis financiero y detección de anomalías.</li>
                </ul>
                <p className="text-calm-muted mt-2">
                  <strong>Importante:</strong> Toda decisión basada en IA es revisable por un asesor humano. 
                  La IA asiste pero nunca sustituye el juicio profesional. 
                  Puedes revocar tu consentimiento para el procesamiento por IA en cualquier momento.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">5. Integración con Sistemas Externos</h2>
                <p className="text-calm-muted">
                  Tus datos contables pueden sincronizarse con el ERP Cegid para garantizar la coherencia 
                  de la información financiera. Esta sincronización:
                </p>
                <ul className="list-disc pl-5 space-y-2 text-calm-muted mt-2">
                  <li>Se realiza mediante conexiones seguras (HTTPS).</li>
                  <li>Los datos del ERP nunca se sobrescriben automáticamente.</li>
                  <li>Toda operación queda registrada en el log de auditoría.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">6. Conservación de Datos</h2>
                <p className="text-calm-muted">Los plazos de conservación se determinan conforme a la legislación española:</p>
                <div className="overflow-x-auto mt-2">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-calm-border">
                        <th className="text-left py-2 pr-4 font-light text-calm-text">Tipo de dato</th>
                        <th className="text-left py-2 pr-4 font-light text-calm-text">Plazo</th>
                        <th className="text-left py-2 font-light text-calm-text">Base legal</th>
                      </tr>
                    </thead>
                    <tbody className="text-calm-muted">
                      <tr className="border-b border-calm-border">
                        <td className="py-2 pr-4">Datos personales</td>
                        <td className="py-2 pr-4">6 años</td>
                        <td className="py-2">Código de Comercio Art. 30</td>
                      </tr>
                      <tr className="border-b border-calm-border">
                        <td className="py-2 pr-4">Documentos fiscales</td>
                        <td className="py-2 pr-4">4 años</td>
                        <td className="py-2">LGT Art. 66</td>
                      </tr>
                      <tr className="border-b border-calm-border">
                        <td className="py-2 pr-4">Datos financieros</td>
                        <td className="py-2 pr-4">6 años</td>
                        <td className="py-2">Código de Comercio Art. 30</td>
                      </tr>
                      <tr className="border-b border-calm-border">
                        <td className="py-2 pr-4">Auditoría</td>
                        <td className="py-2 pr-4">2 años</td>
                        <td className="py-2">RGPD Art. 5(1)(e)</td>
                      </tr>
                      <tr>
                        <td className="py-2 pr-4">Notificaciones</td>
                        <td className="py-2 pr-4">1 año</td>
                        <td className="py-2">RGPD Art. 5(1)(e)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">7. Tus Derechos (Art. 15-22 RGPD)</h2>
                <p className="text-calm-muted">Tienes derecho a:</p>
                <ul className="list-disc pl-5 space-y-2 text-calm-muted mt-2">
                  <li><strong>Acceso (Art. 15):</strong> Obtener copia de todos tus datos personales.</li>
                  <li><strong>Rectificación (Art. 16):</strong> Corregir datos inexactos.</li>
                  <li><strong>Supresión (Art. 17):</strong> Solicitar la eliminación de tus datos (derecho al olvido). Los datos con obligación legal de conservación serán anonimizados.</li>
                  <li><strong>Portabilidad (Art. 20):</strong> Recibir tus datos en formato estructurado (JSON).</li>
                  <li><strong>Limitación (Art. 18):</strong> Restringir el procesamiento de tus datos.</li>
                  <li><strong>Oposición (Art. 21):</strong> Oponerte al tratamiento basado en interés legítimo.</li>
                </ul>
                <p className="text-calm-muted mt-3">
                  Para ejercer estos derechos, puedes:
                </p>
                <ul className="list-disc pl-5 space-y-1 text-calm-muted mt-1">
                  <li>Utilizar las opciones de tu perfil en la plataforma.</li>
                  <li>Enviar un correo a <strong>administracion@externaliza2.com</strong>.</li>
                </ul>
                <p className="text-calm-muted mt-2">
                  Responderemos en un plazo máximo de 30 días conforme al RGPD.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">8. Seguridad</h2>
                <p className="text-calm-muted">
                  Implementamos medidas técnicas y organizativas para proteger tus datos:
                </p>
                <ul className="list-disc pl-5 space-y-1 text-calm-muted mt-2">
                  <li>Comunicaciones cifradas (HTTPS/TLS).</li>
                  <li>Control de acceso basado en roles (RBAC).</li>
                  <li>Row Level Security (RLS) en base de datos.</li>
                  <li>Autenticación segura con JWT.</li>
                  <li>Cabeceras de seguridad HTTP (HSTS, CSP, X-Frame-Options).</li>
                  <li>Registro de auditoría para todas las operaciones sensibles.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">9. Autoridad de Control</h2>
                <p className="text-calm-muted">
                  Si consideras que el tratamiento de tus datos no se ajusta a la normativa, puedes presentar 
                  una reclamación ante la <strong>Agencia Española de Protección de Datos (AEPD)</strong>: 
                  <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1">www.aepd.es</a>
                </p>
              </section>

              <section>
                <h2 className="text-lg font-light text-calm-text mt-8 mb-3">10. Consentimiento</h2>
                <p className="text-calm-muted">
                  Tu consentimiento es libre, específico, informado e inequívoco (Art. 7 RGPD). 
                  Puedes modificar o revocar tus consentimientos en cualquier momento desde tu perfil 
                  o contactando con nosotros. La revocación no afecta la licitud del tratamiento 
                  basado en el consentimiento previo a su retirada.
                </p>
              </section>
            </div>
          </article>

          <p className="text-center text-xs text-calm-muted mt-6">
            &copy; {new Date().getFullYear()} Externaliza2 Consultores, S.L. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </>
  );
}
